const FALLBACK_THREAD_TITLE = 'New conversation';

function pickNonEmptyText(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  return trimmed || null;
}

/**
 * Display label for an AI thread (history list, header, exports).
 * @param {{ title?: string | null, firstMessage?: string | null } | null | undefined} thread
 * @returns {string}
 */
export function getThreadDisplayTitle(thread) {
  const title = pickNonEmptyText(thread?.title);
  if (title) return title;
  const firstMessage = pickNonEmptyText(thread?.firstMessage);
  if (firstMessage) return firstMessage;
  return FALLBACK_THREAD_TITLE;
}
